/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M22 18V17.5V17.4C22 15.1598 22 14.0397 21.564 13.184C21.1805 12.4314 20.5686 11.8195 19.816 11.436C18.9603 11 17.8402 11 15.6 11H14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 11L7 6M2 11L7 16M2 11H13.5H14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M2 11L7 6M2 11L7 16M2 11H15.6C17.8402 11 18.9603 11 19.816 11.436C20.5686 11.8195 21.1805 12.4314 21.564 13.184C22 14.0397 22 15.1598 22 17.4V17.5V18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M2 11L7 6M2 11L7 16M2 11H15.6C17.8402 11 18.9603 11 19.816 11.436C20.5686 11.8195 21.1805 12.4314 21.564 13.184C22 14.0397 22 15.1598 22 17.4V17.5V18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M7 6L2 11H15.6C17.8402 11 18.9603 11 19.816 11.436C20.5686 11.8195 21.1805 12.4314 21.564 13.184C22 14.0397 22 15.1598 22 17.4V17.5V18M7 16L4.5 13.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 11L7 6M2 11L7 16M2 11H15.6C17.8402 11 18.9603 11 19.816 11.436C20.5686 11.8195 21.1805 12.4314 21.564 13.184C22 14.0397 22 15.1598 22 17.4V17.5V18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M2 11L7 6M2 11L7 16M2 11H15.6C17.8402 11 18.9603 11 19.816 11.436C20.5686 11.8195 21.1805 12.4314 21.564 13.184C22 14.0397 22 15.1598 22 17.4V17.5V18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
